/* «Fai la giuria» (home, carrello vuoto) e il volo della foto del capo dalla scheda al cassetto.
   Il gioco: una tavola alla volta, tieni o butta coi bottoni, con le frecce o col dito; la tavola si gira e dice cosa ha deciso la giuria.
   Le scelte restano solo in questo browser (localStorage), nessun conto degli altri. Il cassetto del carrello si riscrive a ogni cambio:
   i giochi nuovi si accendono da soli (MutationObserver), i clic passano tutti da un solo ascoltatore sul documento. */
(function () {
  var MOTO = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CAMPIONI = [0, 1, 2, 3, 11, 100];

  function leggi(k) { try { return JSON.parse(localStorage.getItem(k) || '{}') || {}; } catch (e) { return {}; } }
  function scrivi(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function rtl(el) { return getComputedStyle(el).direction === 'rtl'; }
  function carica(li) {
    if (!li) return;
    var img = li.querySelector('img[data-src]');
    if (!img) return;
    img.srcset = img.getAttribute('data-srcset'); img.src = img.getAttribute('data-src');
    img.removeAttribute('data-srcset'); img.removeAttribute('data-src');
  }

  function Gioco(el) {
    this.el = el; el.__bhg = this;
    this.carte = [].slice.call(el.querySelectorAll('.bhg__tav'));
    this.chiave = 'bhg1-' + el.getAttribute('data-luogo');
    this.scelte = leggi(this.chiave);
    var f = {}; try { f = JSON.parse(el.getAttribute('data-forme') || '{}'); } catch (e) {}
    this.forme = f;
    this.pr = window.Intl && Intl.PluralRules ? new Intl.PluralRules(document.documentElement.lang || 'it') : null;
    this.i = -1;
    /* nella pagina del carrello il gioco si mostra quando i caratteri sono arrivati: sopra di lui il testo cambia altezza e lo spostava */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { el.classList.add('is-pronto'); }); else el.classList.add('is-pronto');
    var primo = this.carte.findIndex(function (c) { return !this.scelte[c.getAttribute('data-id')]; }, this);
    this.mostra(primo < 0 ? this.carte.length - 1 : primo, primo < 0);
    var self = this;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (v) { if (v[0].isIntersecting) { io.disconnect(); self.vicino = true; carica(self.carte[self.i]); carica(self.carte[self.i + 1]); } }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else { this.vicino = true; carica(this.carte[this.i]); }
  }
  Gioco.prototype.mostra = function (i, finito) {
    this.carte.forEach(function (c, j) { c.hidden = j !== i; });
    this.i = i;
    var c = this.carte[i];
    var s = this.scelte[c.getAttribute('data-id')];
    if (s) this.gira(c, s, true); else this.raddrizza(c);
    if (this.vicino) { carica(c); carica(this.carte[i + 1]); }
    var t = this.el.getAttribute('data-contatore') || '';
    this.el.querySelector('.bhg__conta').innerHTML = t.replace('§n', i + 1).replace('§m', this.carte.length);
    this.el.classList.toggle('is-finito', !!finito);
    this.el.querySelector('.bhg__fine').hidden = !finito;
    this.conta();
  };
  Gioco.prototype.raddrizza = function (c) {
    c.classList.remove('is-girata');
    c.querySelector('.bhg__retro').setAttribute('inert', '');
    c.querySelector('.bhg__fronte').removeAttribute('inert');
    this.bottoni(true);
  };
  Gioco.prototype.bottoni = function (on) {
    [].forEach.call(this.el.querySelectorAll('[data-scelta]'), function (b) { b.disabled = !on; });
  };
  Gioco.prototype.gira = function (c, s, subito) {
    var r = c.querySelector('.bhg__retro');
    [].forEach.call(r.querySelectorAll('[data-tu]'), function (p) { p.hidden = p.getAttribute('data-tu') !== s; });
    var slot = r.querySelector('[data-capo-slot]');
    if (slot && !slot.firstChild) {
      var tpl = this.el.querySelector('template[data-capo="' + c.getAttribute('data-capo') + '"]');
      if (tpl) slot.appendChild(tpl.content.cloneNode(true));
    }
    var carta = c.querySelector('.bhg__carta');
    if (subito) carta.style.transition = 'none';
    c.classList.add('is-girata');
    r.removeAttribute('inert');
    c.querySelector('.bhg__fronte').setAttribute('inert', '');
    if (subito) { void carta.offsetWidth; carta.style.transition = ''; }
    this.bottoni(false);
  };
  Gioco.prototype.scegli = function (s) {
    var c = this.carte[this.i];
    if (!c || c.classList.contains('is-girata')) return;
    this.scelte[c.getAttribute('data-id')] = s;
    scrivi(this.chiave, this.scelte);
    this.gira(c, s, false);
    this.conta();
    var p = c.querySelector('[data-bhg-prossima]');
    if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, MOTO ? 450 : 0);
  };
  Gioco.prototype.prossima = function () {
    var self = this, n = this.carte.findIndex(function (c, j) { return j > self.i && !self.scelte[c.getAttribute('data-id')]; });
    if (n < 0) n = this.carte.findIndex(function (c) { return !self.scelte[c.getAttribute('data-id')]; });
    if (n < 0) { this.mostra(this.i, true); var r = this.el.querySelector('[data-bhg-rifai]'); if (r) r.focus({ preventScroll: true }); return; }
    this.mostra(n, false);
    var b = this.el.querySelector('[data-scelta="t"]'); if (b) b.focus({ preventScroll: true });
  };
  Gioco.prototype.rifai = function () {
    this.scelte = {}; scrivi(this.chiave, {});
    this.carte.forEach(this.raddrizza, this);
    this.mostra(0, false);
  };
  Gioco.prototype.conta = function () {
    var p = this.el.querySelector('.bhg__accordo'), m = 0, n = 0, self = this;
    this.carte.forEach(function (c) { var s = self.scelte[c.getAttribute('data-id')]; if (s) { m++; if (s === c.getAttribute('data-esito')) n++; } });
    if (!m || !this.pr) { p.innerHTML = ''; return; }
    var cat = this.pr.select(n), s = CAMPIONI.indexOf(n) > -1 ? n : CAMPIONI.filter(function (x) { return self.pr.select(x) === cat; })[0];
    if (s === undefined) s = 100;
    var t = this.forme[String(s)] || '';
    p.innerHTML = t.replace('§m', m).replace('<bdi>' + s + '</bdi>', '<bdi>' + n + '</bdi>');
  };

  function accendi(root) {
    [].forEach.call((root || document).querySelectorAll('[data-bhg]'), function (el) { if (!el.__bhg) new Gioco(el); });
  }

  /* il gesto col dito sulla tavola: oltre 60 px a destra o a sinistra decide, verso il bottone di quella parte */
  var tocco = null;
  document.addEventListener('pointerdown', function (e) {
    var f = e.target.closest && e.target.closest('.bhg__fronte');
    if (!f || f.hasAttribute('inert') || e.button > 0) return;
    var g = f.closest('[data-bhg]'); if (!g || !g.__bhg) return;
    tocco = { f: f, g: g, x: e.clientX, y: e.clientY, dx: 0, id: e.pointerId, carta: f.parentNode };
  });
  document.addEventListener('pointermove', function (e) {
    if (!tocco || e.pointerId !== tocco.id) return;
    tocco.dx = e.clientX - tocco.x;
    if (Math.abs(tocco.dx) < 8) return;
    if (!tocco.preso) { tocco.preso = true; try { tocco.f.setPointerCapture(e.pointerId); } catch (x) {} tocco.carta.style.transition = 'none'; }
    var d = tocco.dx, dir = (d > 0) !== rtl(tocco.g) ? 't' : 'b';
    tocco.carta.style.transform = 'translateX(' + d + 'px) rotate(' + (d / 24) + 'deg)';
    [].forEach.call(tocco.f.querySelectorAll('.bhg__segno'), function (s) { s.style.opacity = s.classList.contains('bhg__segno--' + dir) ? Math.min(1, Math.abs(d) / 60) : 0; });
  });
  function fine(e) {
    if (!tocco || e.pointerId !== tocco.id) return;
    var t = tocco; tocco = null;
    t.carta.style.transform = ''; t.carta.style.transition = '';
    [].forEach.call(t.f.querySelectorAll('.bhg__segno'), function (s) { s.style.opacity = ''; });
    if (t.preso && Math.abs(t.dx) > 60 && e.type === 'pointerup') t.g.__bhg.scegli((t.dx > 0) !== rtl(t.g) ? 't' : 'b');
  }
  document.addEventListener('pointerup', fine);
  document.addEventListener('pointercancel', fine);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-scelta],[data-bhg-prossima],[data-bhg-rifai]');
    if (!b) return;
    var g = b.closest('[data-bhg]'); if (!g || !g.__bhg) return;
    if (b.hasAttribute('data-scelta')) g.__bhg.scegli(b.getAttribute('data-scelta'));
    else if (b.hasAttribute('data-bhg-prossima')) g.__bhg.prossima();
    else g.__bhg.rifai();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var g = e.target.closest && e.target.closest('[data-bhg]'); if (!g || !g.__bhg) return;
    if (e.target.matches('input, textarea')) return;
    e.preventDefault();
    g.__bhg.scegli((e.key === 'ArrowRight') !== rtl(g) ? 't' : 'b');
  });

  /* dalla scheda al cassetto: la foto del capo vola nella prima riga del cassetto (stessa API, dentro la pagina) */
  function voloCassetto() {
    if (!window.customElements || !document.startViewTransition || !MOTO) return;
    customElements.whenDefined('cart-drawer').then(function () { patch(customElements.get('cart-drawer')); });
  }
  function patch(CD) {
    if (!CD || CD.prototype.__bhq) return;
    CD.prototype.__bhq = true;
    var orig = CD.prototype.renderContents;
    CD.prototype.renderContents = function (stato) {
      var self = this;
      var src = document.querySelector('#MainContent .product__media-list > li.bh-sn-prima img') || document.querySelector('#MainContent .product__media-list > li:first-child img');
      var r = src && src.getBoundingClientRect();
      if (!src || !r || r.bottom < 0 || r.top > innerHeight) return orig.call(this, stato);
      var dest = null, inner = null;
      var vt;
      try {
        vt = document.startViewTransition(function () {
          orig.call(self, stato);
          try {
            inner = self.querySelector('.drawer__inner');
            if (inner) inner.style.transition = 'none';
            self.style.transition = 'none';
            self.classList.add('animate', 'active');
            src.style.viewTransitionName = 'none';
            dest = self.querySelector('.drawer__cart-item__media img');
            if (dest) dest.style.viewTransitionName = 'bh-capo';
          } catch (x) {}
        });
      } catch (x) { return orig.call(this, stato); }
      document.documentElement.setAttribute('data-bhq-volo', '1');
      vt.finished.finally(function () {
        src.style.viewTransitionName = ''; if (dest) dest.style.viewTransitionName = '';
        if (inner) inner.style.transition = ''; self.style.transition = '';
      });
    };
  }

  function via() {
    accendi(document);
    voloCassetto();
    var cd = document.querySelector('cart-drawer');
    if (cd && 'MutationObserver' in window) new MutationObserver(function () { accendi(cd); }).observe(cd, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', via); else via();
})();
